<template>
    <div>
        <!-- <pre>{{ permissions }}</pre> -->
        <template v-if="action == 'view'">
            <div class="table-settings mb-4" v-if="allData.length > 0 || q != ''">
                <div class="row align-items-center justify-content-between">
                    <div class="col col-md-6 col-lg-3 col-xl-4">
                    </div>
                    <div class="col-4 col-md-2  pl-md-0 text-right">
                    </div>
                </div>
            </div>
            <div class="card border-light shadow-sm mb-4">
                <div style="position: absolute; margin-top: 120px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);"
                    v-if="!permissions.find(e => e.permission_name == 'View Categories')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
                        permission.</span>
                </div>
                <div
                    :style="!permissions.find(e => e.permission_name == 'View Categories') ? 'filter: blur(4px); pointer-events: none;' : ''">
                    <div class="col-12 d-flex flex-row-reverse pt-3 pr-5">
                        <MssInput type="switch" v-model="category_status" @input="allDatas()"
                            :placeholder="category_status ? 'Active Category' : 'Inactive Category'"></MssInput>
                    </div>
                    <div class="card-body" v-if="(allData.length > 0)">
                        <table class="table table-hover">
                            <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <!-- <th>Image</th> -->
                                    <th>Price</th>
                                    <th>Design Price</th>
                                    <th>Source file Price</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="allData.length > 0">
                                <tr v-for="(data, key) in allData" :key="key">
                                    <td>
                                        <a href="#" class="font-weight-bold">
                                            {{ key + 1 }}
                                        </a>
                                    </td>
                                    <td><span class="font-weight-normal">{{ data.category_name }}</span></td>
                                    <!-- <td><span class="font-weight-normal">
                                        <img v-if="data.photo!=''" :src="$root.URL_ROOT+'uploads/Category/'+data.photo" width="50">
                                    </span></td> -->
                                    <td>{{ data.price }}</td>
                                    <td>{{ data.des_price }}</td>
                                    <td>{{ data.sprice ? data.sprice : 0 }}</td>
                                    <td><span class="font-weight-bold">
                                            <button
                                                :disabled="!permissions.find(e => e.permission_name == 'Active/Inactive Category')"
                                                class="btn btn-danger btn-xs" href="#" @click="updateStatus(data, 1)"
                                                v-if="data.status == 0"> Inactive</button>
                                            <button
                                                :disabled="!permissions.find(e => e.permission_name == 'Active/Inactive Category')"
                                                class="btn btn-success btn-xs" href="#" @click="updateStatus(data, 0)"
                                                v-if="data.status == 1"> Active</button>
                                        </span></td>
                                    <td>
                                        <div class="btn-group">
                                            <router-link class="btn btn-success btn-xs"
                                                :to="{ name: 'index', params: { page: 'subcategory', action: 'view', id: data.id, code: data.id } }"><span
                                                    class="fa fa-eye mr-2"></span>Subcategory</router-link>
                                            <router-link class="btn btn-primary btn-xs"
                                                :to="{ name: 'index', params: { page: page, action: 'edit', id: data.id } }"><span
                                                    class="fa fa-edit mr-2"></span>Edit</router-link>
                                            <!-- <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a> -->
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td class="text-center" colspan="5">No record found</td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination mb-0">
                                <template v-for="(paginate,key) in allData">
                                    <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                        <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                    </li>
                                </template>
</ul>
</nav>
<div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total
    record <b>{{allData.total}}</b></div>
</div> -->

                    </div>
                    <div class="card-body text-center" v-else>
                        <div v-if="loading">
                            loading...
                        </div>
                        <div v-else>
                            <div>
                                <h3>Add and manage your {{ page }}</h3>
                                <p>This is where you’ll add {{ page }} and manage theme. You can also improve your
                                    website
                                    by adding.</p>
                                <router-link :to="{ name: 'index', params: { page: page, action: 'add' } }"
                                    class="btn btn-primary" type="button">Add {{ page }}</router-link>
                                <br><br><br>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template v-else>
            <div class="row">
                <div style="position: absolute; margin-top: 200px; z-index: 1; width: max-content; left: 50%;"
                    v-if="action == 'add' && !permissions.find(e => e.permission_name == 'Create Category')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the creating
                        permission.</span>
                </div>
                <div style="position: absolute; margin-top: 200px; z-index: 1; width: max-content; left: 50%;"
                    v-else-if="action == 'edit' && !permissions.find(e => e.permission_name == 'Edit Category')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the updating
                        permission.</span>
                </div>
                <div
                    :style="(action == 'add' && !permissions.find(e => e.permission_name == 'Create Category')) || (action == 'edit' && !permissions.find(e => e.permission_name == 'Edit Category')) ? 'filter: blur(4px); pointer-events: none;' : ''">
                    <div class="col-12 col-xl-8">
                        <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <h2 class="h5 mb-4">General information</h2>
                            <div class="row">
                                <div :class="action == 'edit' ? 'col-md-6 mb-3' : 'col-md-12 mb-3'">

                                    <MssInput v-model="form.category_name" placeholder="Enter Page Heading" required>
                                    </MssInput>
                                </div>
                                <div class="col-md-6 mb-3" v-if="action == 'edit'">
                                    <MssInput v-model="form.id" disabled placeholder="Category Id"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput v-model="form.sprice" placeholder="Source file price"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput v-model="form.price" placeholder="Price"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput v-model="form.des_price" placeholder="Design Price"></MssInput>
                                </div>

                                <div class="col-md-12 mb-3">
                                    <label>Category Images <span> <i v-if="false">(Upload Image max width 1806 x height
                                                1806 Pixels and image size max 1MB) </i> </span> </label>
                                    <input type="file" id="files" name="file" ref="images" @change="handleFileChange"
                                        accept=".png, .jpg, .jpeg" multiple class="form-control my-3">
                                    <span class="text-danger">
                                        * Image resolution has to be 640px X 360px, Supported file extensions: ".png,
                                        .jpg, .jpeg"
                                    </span>
                                    <!-- <img  v-if="action=='edit'" :src="$root.URL_ROOT+'uploads/Category/'+form.photo" style="margin-top:20px;" width="100"> -->
                                    <div class="d-flex flex-row" style="overflow: hidden; overflow-x: auto;">
                                        <!-- <pre>{{ form.images }}</pre> -->
                                        <div class="card" style="width: max-content;"
                                            v-for="(image, index) in form.images">
                                            <i @click.prevent="deleteImageForProduct(image.id)"
                                                style="position: absolute; right: 0; top: 0; color: red; cursor: pointer;"
                                                class="fa fa-times"></i>
                                            <img height="100" :src="image.image_url" :alt="form.category_name">
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Media <span>( Select multiple images )</span> </h2>
                         <i>(Image max width 1806 x height 1806 Pixels and image size max 1MB) </i> -->
                                <!-- <MssImage folder="product" v-model="form.image_collection" :selected="form.image_collection"></MssImage> -->
                                <!-- <input class="form-control" type="file" id="file" ref="image_collection" multiple accept="image/*" />
                        <div class="py-3 ">
                            <img v-for="(images,key) in allimages" :key="key" :src="$root.URL_ROOT+'uploads/Product/'+images" class="mx-3" width="50">
                        </div>
                    </div> -->

                                <!-- <div class="col-md-6 mb-3 hide">
                                <label>Banner Image <span> <i>(Upload Image max width 1806 x height 1806 Pixels and image size max 1MB) </i></span> </label>
                                <input class="form-control" type="file" id="banner" ref="banner" accept="image/*" />
                                <img  v-if="action=='edit'" :src="$root.URL_ROOT+'uploads/Category/'+form.icon" style="margin-top:20px;" width="100">
                            </div> -->



                                <div class="col-md-6 mb-3 text-center">
                                </div>
                                <div class="row align-items-center">
                                    <div class="col-md-12 mb-3">
                                        <!-- <div class="pull-right">
                                        <MssInput type="switch" v-model="isEditor" :placeholder="isEditor ? 'Source Code' : 'View Editor'"></MssInput>
                                    </div> -->
                                        <label for="birthday">Description ({{ form.category_description.length }} /
                                            1000)
                                            <span class="red-color">*</span></label>
                                        <!-- <vue-editor v-if="isEditor" v-model="form.pbody" :editorToolbar="fullToolbar"></vue-editor> -->
                                        <span class="text-danger"
                                            v-if="form.category_description.length > 1000">Description cannot be more
                                            than 1000 characters.</span>
                                        <!-- <pre>{{ form.category_description }}</pre> -->
                                        <VueEditor v-model="form.category_description" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-4 sidebar-stricky">
                        <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <h2 class="h5 mb-4">Other Options</h2>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.status" placeholder="Visible"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.print" placeholder="Print"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.design" placeholder="Design"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput type="switch" v-model="form.design_n_print" placeholder="Design & Print">
                                    </MssInput>
                                </div>
                                <!-- <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.is_featured" placeholder="Is Feature"></MssInput>
                            </div> -->
                                <div class="col-md-12 mb-3">
                                    <div>
                                        <button @click="submit" :disabled="form.category_description.length > 1000"
                                            class="btn btn-info btn-block" v-if="action == 'add'">Publish</button>
                                        <button @click="submit" :disabled="form.category_description.length > 1000"
                                            class="btn btn-success btn-block" v-else>Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="card card-body bg-white border-light shadow-sm mb-4">
                            <div class="row">
                                <h2 class="col-md-8 h5 mb-4">SEO information</h2>
                                <div class="col-md-4 text-right">
                                    <button @click="defaultSEO=false;editSEO = editSEO ? false : true" class="btn btn-info btn-xs"><span class="far fa-edit mr-2"></span>Edit</button>
                                </div>
                            </div>
                            <div class="row" v-if="editSEO">
                                <div class="col-md-6 mb-3">
                                    <MssInput v-model="form.meta_title" placeholder="SEO title of this page"></MssInput>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <MssInput v-model="form.meta_keywords" placeholder="keywords for this page"></MssInput>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <MssInput type="textarea" v-model="form.meta_description" placeholder="Seo Description max 150 char"></MssInput>
                                </div>
                            </div>
                            <div v-else class="row align-items-center">
                                <h3>{{form.meta_title}}</h3>
                                <a href="javascript:;">{{URL_ROOT}}category/{{form.linkname}}</a>
                                <p>{{limitedword(striphtml(form.meta_description),150)}}</p>
    
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {
    VueEditor
} from "vue2-editor";
import $ from 'jquery'
import axios from 'axios'
export default {
    components: {
        VueEditor
    },
    props: [
        "page", "action", "id", "type"
    ],
    data() {
        return {
            category_status: true,
            selectedCategory: null,
            isEditor: true,
            loading: false,
            allData: [],
            allFiles: null,
            selected_files: [],
            form: {
                id: null,
                lorder: 0,
                status: true,
                heading: '',
                photo: '',
                images: null,
                is_parent: 0,
                is_featured: true,
                type: 'category_save',
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6,]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                ['clean'],
            ],
            viewAllUrl: '',
            permissions: null,
        }
    },
    methods: {
        async deleteImageForProduct(id) {
            const data = {
                type: "deleteImageForProduct",
                image_id: id
            }
            const response = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data
            })
            this.$toasted.global[response.data.status]({
                message: response.data.msg
            })
            if (response.data.status = 'success') {
                this.form.images = this.form.images.filter(e => e.id != id)
            }
        },
        updateStatus(data, status) {
            var ev = this
            const updateData = {
                cat_id: data.id,
                cat_name: data.category_name,
                cat_desc: data.category_description,
                cat_price: data.price,
                cat_status: status,
                type: 'updateCategory'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: updateData
            }).then((response) => {
                ev.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
                ev.newAllDatas()
            })
        },
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },
        addInit() {
            this.getUnderof();
            this.reset()
        },
        editInit() {
            this.getDetail();
            // this.getUnderof();
        },
        viewInit() {
            this.newAllDatas()
        },
        reset() {
            this.form = {
                id: null,
                type: 'category_save',
                lorder: 0,
                status: true,
                heading: '',
                file: '',
                is_parent: 0,
                is_featured: true
            };
        },
        getUnderof() {
            var pList = [];
            pList.push({
                label: 'Parent',
                code: 0
            })
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php?type=getCategory',
            }).then(function (response) {
                var data = response.data;
                $.each(data, function (key, param) {
                    pList.push({
                        label: param.heading,
                        code: param.id
                    })
                })
            })

        },
        upload_file() {
            // var ev = this;
            this.file = this.$refs.file.files[0];

            // let formData = new FormData();
            // console.log(formData);
            // this.save_userimage();

        },
        // save_userimage: function () {
        //     var ev = this;
        //     this.file = this.$refs.file.files[0];

        //     let formData = new FormData();

        //     formData.append('photo', this.file);
        //     formData.append('id', this.id);

        //     if (this.file == undefined) {
        //         ev.$swal({
        //             message: "please upload image"
        //         });
        //     } else {
        //      if(this.action=='edit'){
        //         axios.post(this.$root.URL_ROOT + 'api.php?type=category_edit', formData, {
        //                 headers: {
        //                     'Content-Type': 'multipart/form-data'
        //                 }
        //             })
        //             .then(function (response) {
        //                 var data = response.data;
        //                 //console.log(data);
        //                 if (data.status == "success") {
        //                     ev.$swal({
        //                         title: data.msg,
        //                     });
        //                     // ev.getUserDetail();

        //                 } else {
        //                     ev.$swal({
        //                         title: data.msg,
        //         // text:data.msg
        //                     });
        //                 }
        //             })
        //     }
        //     }

        // },
        getDetail() {
            var ev = this
            var param = {
                cat_id: this.id
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetchAllCategories',
                data: param
            }).then(function (response) {
                var data = response.data;
                ev.form = data.data[0]
            })
        },
        newAllDatas() {
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=fetchAllCategories',
                data: {
                    status: ev.category_status
                }
            }).then(function (response) {
                var data = response.data;
                ev.allData = data.data
            })
        },
        allDatas() {
            this.newAllDatas()
            return
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php?type=getCategory',
                data: {
                    page_no: 2,
                    limit: 5
                }
            }).then(function (response) {
                var data = response.data;
                console.log(data);
                ev.allData = data
            })
        },
        handleFileChange(event) {
            const ev = this
            this.allFiles = new FormData()
            let item = 1
            event.target.files.forEach(e => {
                let img = new Image()
                img.src = window.URL.createObjectURL(e)
                img.addEventListener('load', function () {
                    if (img.width != 640 && img.height != 360) {
                        ev.$toasted.global.error({
                            message: `${e.name} is not matching 640px X 360px.`
                        })
                        document.getElementById('files').value = null
                    } else {
                        ev.allFiles.append(`file${item}`, e)
                        item += 1
                    }
                })
            })
        },
        submit() {
            var ev = this
            // this.file = this.$refs.file.files[0];
            // this.file = this.$refs.front_image.files[0];
            // this.banner = this.$refs.banner.files[0];

            if (!this.form.category_name || this.form.category_name === '') {
                console.log(this.form.category_name);
                ev.$toasted.global.error({
                    message: 'Please enter a category name.'
                })
                return
            }
            if (!this.form.price || this.form.price === '') {
                ev.$toasted.global.error({
                    message: 'Please enter a category price.'
                })
                return
            }
            if (!this.form.des_price || this.form.des_price === '') {
                ev.$toasted.global.error({
                    message: 'Please enter a category design price.'
                })
                return
            }
            let status = ''

            if (this.form.status == true) {
                status = 1
            } else {
                status = 0
            }
            // let formData = new FormData();
            // if (this.action == 'edit') {
            //     formData.append('cat_id', this.id);
            //     // this.form.type = 'category_edit';
            // }
            // formData.append('image_collection', this.$refs.image_collection.files);
            // for (var i = 0; i < this.$refs.image_collection.files.length; i++) {
            //     let file = this.$refs.image_collection.files[i];
            //     formData.append('image_collection[' + i + ']', file);
            // }
            // formData.append('lorder', this.form.lorder);
            // formData.append('banner', this.banner);
            // formData.append('photo', this.file);
            // formData.append('cat_name', this.form.category_name);
            // formData.append('cat_desc', this.form.category_description);
            // formData.append('cat_status', status);
            // formData.append('cat_price', this.form.price);
            // formData.append('is_featured', this.form.is_featured);
            // formData.append('type', this.form.type);
            const data = this.action == 'edit' ? {
                cat_id: this.id,
                cat_name: this.form.category_name,
                cat_desc: this.form.category_description,
                cat_price: this.form.price,
                cat_sprice: this.form.sprice,
                cat_des_price: this.form.des_price,
                cat_print: this.form.print,
                cat_design: this.form.design,
                cat_designnprint: this.form.design_n_print,
                cat_status: status,
                type: 'updateCategory'
            } : {
                cat_name: this.form.category_name,
                cat_desc: this.form.category_description,
                cat_price: this.form.price,
                cat_sprice: this.form.sprice,
                cat_des_price: this.form.des_price,
                cat_print: this.form.print,
                cat_design: this.form.design,
                cat_designnprint: this.form.design_n_print,
                cat_status: status,
                type: 'createNewCategory'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: data
            }).then(function (response) {
                var data = response.data;
                if (data.status == "success") {
                    axios({
                        method: 'POST',
                        url: ev.$root.URL_ROOT + 'updatedApiForProducts.php?type=uploadImageForProduct',
                        data: ev.allFiles
                    }).then((response) => {
                        const image_ids = response.data.data.map(e => {
                            return parseInt(e)
                        })
                        const cat_id = parseInt(data.data)
                        axios({
                            method: 'POST',
                            url: ev.$root.URL_ROOT + 'updatedApiForProducts.php?type=assignProductDetails',
                            data: ev.action == 'edit' ? {
                                image_ids, cat_id: ev.id
                            } : {
                                image_ids, cat_id
                            }
                        }).then((response) => {
                            console.log(response);
                            ev.$swal({
                                toast: true,
                                position: 'top-end',
                                timer: 5000,
                                icon: 'success',
                                timerProgressBar: true,
                                title: 'Action perform successfully'
                            })
                            ev.$router.push({
                                name: 'index',
                                params: {
                                    page: ev.page,
                                    // action: 'edit',
                                    // id: response.data.id
                                }
                            })
                        })
                    })
                } else {

                    setTimeout(() => ev.$swal(data.msg), 1000);

                }
            })
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_category',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        console.log('commonDelete', data)
                        self.allDatas()
                    })
                }
            })
        }
    },
    mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'CATEGORY' && e.has_permission == true)
        }
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
        'form.linkname': function (val) {
            var text = val.replace(' ', "")
            this.form.linkname = text
        },
        'loading': function (val) {
            if (val) {
                this.$swal.showLoading();
            } else {
                this.$swal.close()
            }
        },
        'q': function (newVal, oldVal) {
            if (newVal == '') {
                this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all';
            } else if (newVal != oldVal) {
                this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all/' + newVal;
            }
            this.allDatas(false);
        }
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
